import { Col, Form, Spin } from "antd";
import "antd/dist/antd.min.css";
import PropTypes from "prop-types";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { getRequest, patchRequest, postRequest } from "../../../axios";
import ButtonField from "../../../common/htmlComponents/ButtonField";
import InputField from "../../../common/htmlComponents/InputField";
import { ReactComponent as SearchLocation } from "../../../image/SearchLocation.svg";
import "../../../styles/Main.scss";
import { SuccessNotificationMsg } from "../../../utils/Notifications";

const AddZoneModel = ({ handleCancel, setReload, zoneId, modalKey, setStateM }) => {
  const { t } = useTranslation();
  const formRef = useRef();

  // State initialisation
  const initialState = {
    zone_name: "",
  };
  const [state, setState] = useState(initialState);
  const [btnLoading, setBtnLoading] = useState(false); // Loading state for the submit button
  const [apiLoading, setapiLoading] = useState(false); // Loading state for API calls


  // Fetch zone details if `zoneId` is provided
  useEffect(() => {
    const zoneGetById = async () => {
      if (zoneId !== null) {
        try {
          setapiLoading(true);
          const response = await getRequest(`zonename/${zoneId}/`);
          setState(response.data.data);
          formRef.current.setFieldsValue(response.data.data);
          setapiLoading(false);
        } catch (error) {
          setapiLoading(false);
        }
      }
    };
    zoneGetById();
  }, [zoneId, modalKey]);

  // Handle Escape key to cancel the form
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        backToList();
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  // Handle input change
  const handleInputChange = (e) => {
    let { name, value } = e.target;
    setState({ ...state, [name]: value.toUpperCase() });
  };

  // Reset form and close modal
  const backToList = () => {
    setState(initialState);
    formRef.current.setFieldsValue(initialState);
    handleCancel();
  };

  // Handle form submission
  const handleSubmit = async () => {
    try {
      setBtnLoading(true);
      let response;
      if (zoneId === null) {
        response = await postRequest("zonename/", state);
      } else {
        response = await patchRequest(`zonename/${zoneId}/`, state);
      }
      if (response.data.success) {

        SuccessNotificationMsg(
          zoneId === null
            ? t("zone_name_added_successfully2")
            : t("zone_name_updated_successfully2")
        );
        setState(initialState);
        setStateM((prev) => ({
          ...prev,
          page: 1
        }));

        formRef.current.setFieldsValue(initialState);
        setBtnLoading(false);
        handleCancel();
        setReload((reload) => !reload);

      }
    } catch (error) {
      setBtnLoading(false);
    }
  };

  return (
    <>
      <Spin spinning={apiLoading}>
        <Form
          className="ModalForm"
          onFinish={handleSubmit}
          autoComplete="off"
          ref={formRef}
          initialValues={state}
        >
          <Col md={24} className="TextFeild">
            <InputField
              name="zone_name"
              label={t("pl_zone_name")}
              placeholder={t("pl_add_zone")}
              handleInputChange={handleInputChange}
              prefix={<SearchLocation />}
              rules={t("val_zone_name")}
              pattern={"^[a-zA-Z ]+$"}
              max={20}

            />
          </Col>
          <div className="ModalPopupFooter">
            <ButtonField
              className="CancelGradiantBtn"
              type="primary"
              htmlType="button"
              label={t("cancel")}
              onClick={backToList}
            />
            <ButtonField
              className="SaveGradiantBtn"
              type="primary"
              htmlType="Submit"
              label={t("Add")}
              loading={btnLoading}
            />
          </div>
        </Form>
      </Spin>
    </>
  );
};

AddZoneModel.propTypes = {
  handleCancel: PropTypes.func.isRequired,
  setReload: PropTypes.func.isRequired,
  zoneId: PropTypes.number,
  modalKey: PropTypes.bool,
  setStateM: PropTypes.func.isRequired
};

export default AddZoneModel;
